import NotFound from './NotFound'
import ForgotPassword from './ForgotPassword'
import JwtRegister from './register/JwtRegister'
import JwtLogin from './login/JwtLogin'
import ResetPassword from './ResetPassword'
import JwtLogout from './logout/JwtLogout'
import ResgateCupomPage from '../../../pages/Anunciantes/ResgateCupomPage'

const sessionRoutes = [
    {
        path: '/session/signup',
        component: JwtRegister,
    },
    {
        path: '/session/signin',
        component: JwtLogin,
    },
    {
        path: '/session/forgot-password',
        component: ForgotPassword,
    },
    {
        path: '/session/404',
        component: NotFound,
    },
    {
        path: '/session/reset-password',
        component: ResetPassword,
    },
    {
        path: '/session/signout',
        component: JwtLogout,
    },
    {
        path: '/anunciantes/resgate-cupom',
        component: ResgateCupomPage,
    },
    {
        path: '/parceiros/resgate-cupom',
        component: ResgateCupomPage,
    },
]

export default sessionRoutes
